import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";

export const useOdlaczKontoOdProfilu = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({profilId, userId}) =>
            deleteItem(`profile/${profilId}/odlacz/${userId}`),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`profile_konta_polaczone`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
    });
};
